module.exports = __webpack_public_path__ + "static/media/aoi_gcs.82345358.zip";